import testimonial_img_1 from "../assets/training/training-test-1.png";
import testimonial_img_2 from "../assets/training/training-test-2.png";
import testimonial_img_3 from "../assets/training/training-test-3.png";
import evidence_img1 from "../assets/evidence/img1.png";
import evidence_img2 from "../assets/evidence/img2.png";
import evidence_img3 from "../assets/evidence/img3.png";
import curriculum_img1 from "../assets/curriculum/curriculum1.png";
import curriculum_img2 from "../assets/curriculum/curriculum2.png";
import curriculum_img3 from "../assets/curriculum/curriculum3.png";

export const trainingTestimonials = [
  {
    img: testimonial_img_1,
    text: "<span>This engaging training program was eye- opening and inspiring. The sessions used simple tools to deliver powerful concepts through hands-on learning. I’m now motivated to bring similar excitement, curiosity, and active learning into my own classroom.</span><span>-Kanchana,<br>GHSS - Poondi</span>",
  },
  {
    img: testimonial_img_2,
    text: "<span>As a Physics teacher, I had a foundational understanding of electronics and breadboards, but this training provided me with practical exposure and a deeper understanding. It has strengthened both my confidence and my teaching approach.</span><span>-G. Kishore Kumar,<br>MMS - Kagithapattarai</span>",
  },
  {
    img: testimonial_img_3,
    text: "<span>This training provided a wealth of ideas to make teaching more interesting and student-focused. The sessions were designed to be engaging and collaborative, encouraging us to work together to find solutions to different problems.</span><span>-Mrs Mamatamayee Khuntia,<br>Madhuban High School</span>",
  },
];

export const evidenceTestimonials = [
  {
    img: evidence_img1,
    text: "MakerDost allows teachers to express their thoughts and suggestions on how the sessions can be improved further. I truly appreciate that it includes the teacher’s perspective in the process. It makes me feel that our ideas and voices are valued.",
  },
  {
    img: evidence_img2,
    text: "Makerdost has been very helpful in recording students’ behaviour in the classroom. While entering details, it helped me reflect on how the session went and where improvements were needed, and find new ways to make my teaching more effective.",
  },
  {
    img: evidence_img3,
    text: "I was not very familiar with using technology, but Makerdost was easy to adapt. The questions were very clear, effective, and simple to fill in. Over time, I have become more confident in using tech in upcoming session activities.",
  },
];

export const curriculumTestimonials = [
  {
    img: curriculum_img1,
    text: "<span>The hands-on, activity-based approach connects theory with real-life applications. I’ve seen students grow curious, creative, and confident problem-solvers, making classroom teaching richer and transforming learning into an exciting, engaging experience.</span><span>-Rajashree Purohit,<br>Samaleswari Nodal High School, Bargarh</span>",
  },
  {
    img: curriculum_img2,
    text: "<span>The curriculum’s step-by-step instructions with visuals boost my confidence, simplify complex topics, and ensure student understanding, making classroom sessions more interactive, engaging, and effective for better learning outcomes.</span><span>-Kamatchi,<br>MMS- Kalaspalayam</span>",
  },
  {
    img: curriculum_img3,
    text: "<span>MakerGhat's curriculum is very clear and easy to follow, for teachers who are handling these activities for the first time. I found that it not only guides us but also builds our confidence. It truly supports effective teaching and joyful learning</span><span>-Laxmi,<br>PUMS- Sevoor</span>",
  },
];

export const fellowshipTestimonials = [
  {
    quote:
      "I strongly believe that hands-on science education can create a meaningful, lasting impact in society. Joining MakerGhat helped me overcome self-doubt and grow in confidence while working with rural children, learning by doing and contributing to equitable, science-led education at the grassroots.",
    author: "- Ankita Pawne",
    image: "image-1",
  },
  {
    quote:
      "My journey in education is driven by a deep passion for creating learning spaces that are inclusive, equitable, and grounded in empathy. MakerGhat Fellowship gives me the possibility to combine research and practice towards creating context-responsive, equitable educational change.",
    author: "- Santana Parui",
    image: "image-3",
  },
  {
    quote:
      "After completing my Master’s degree, I chose to begin my career in education because it offers direct grassroots exposure and meaningful engagement with communities. The MakerGhat Fellowship provides the practical, community-level experience needed to build a strong foundation for my career.",
    author: "- Sudipto Ghosh",
    image: "image-4",
  },
  {
    quote:
      "Working with the community has been a transformative experience for me. I’ve found great joy in understanding local needs and teaching students through hands-on learning. This journey has significantly boosted my confidence, allowing me to grow personally while contributing to meaningful, science-led education that empowers rural children at the grassroots.",
    author: "- Gauri Hitendra Dakre",
    image: "image-2",
  },
];
